
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/monolith-to-microservices",
      function () {
        return require("private-next-pages/books/monolith-to-microservices.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/monolith-to-microservices"])
      });
    }
  